import { render } from "./EyerwebPatientInfoTab.vue?vue&type=template&id=c58f7214"
import script from "./EyerwebPatientInfoTab.vue?vue&type=script&lang=js"
export * from "./EyerwebPatientInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__